import * as logger from "../../utils/logger";
import { handleJSNative } from "../error";
import { AppType, getAppType } from "./nativeHelpers";

function optionsToOptionString(options: IExternalUrlOpenOptions | undefined) {
    let optionsString: string | undefined;
    if (options) {
        let optionsArray: string[] = [];
        Object.keys(options).forEach(key => {
            let option = options[key];
            let optionText = option === true ? "yes" : (option === false ? "no" : option);
            optionsArray.push(`${ key }=${ optionText }`);
        });
        optionsString = optionsArray.join(",");
    }
    return optionsString;
}

function openExternalUrlByCordova(url: string, target: TExternalUrlOpenTarget  = "_system", options?: IExternalUrlOpenOptions): any {
    let optionsString: string | undefined = optionsToOptionString(options);
    let linkTarget = target;
    if (target === "_self" || target === "iab") {
        // Target "_self" causes the app to crash. Rewrite to "_blank".
        // Also ensure that "iab" rewrites to "_blank" on Cordova to be 100% sure it will use the InAppBrowser.
        linkTarget = "_blank";
    }
    return window.cordova.InAppBrowser.open(url, linkTarget, optionsString);
}

function openExternalUrlByNativeSDK(url: string, target: TExternalUrlOpenTarget = "_system", options?: IExternalUrlOpenOptions): any {
    let optionsString: string | undefined = optionsToOptionString(options);
    if (window.geotabModules) {
        window.geotabModules.browser.openBrowserWindow({url: url, target: target || "_blank", features: optionsString}, (error) => {
            if (error) {
                logger.error(logger.Source.NATIVE, `openExternalUrl: Error: ${ error.message }`);
            }
        });
    }
    return null;
}

function openExternalUrlByWeb(url: string, target: TExternalUrlOpenTarget) {
    if (target === "_blank") {
        window.open(url, target);
    } else {
        window.location.href = url;
    }
    return null;
}

export function openExternalUrl(url: string, target: TExternalUrlOpenTarget = "_system", options?: IExternalUrlOpenOptions): any {
    try {
        switch (getAppType()) {
            case AppType.CordovaApp:
                return openExternalUrlByCordova(url, target, options);
            case AppType.NativeSdk:
                return openExternalUrlByNativeSDK(url, target, options);
            case AppType.WebApp:
                return openExternalUrlByWeb(url, target);
            default:
                return null;
        }
    } catch (error) {
        handleJSNative(error instanceof Error ? error : new Error(error), true, "nativeUnhandledException");
    }
}